import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { PresenceHoverCard } from '..';

interface MBPHoverPopupProps {
    presence: any;
    companyName: string;
    focusedPoi?: any;
    roi: { north: number; south: number; east: number; west: number; } | null;
    onClose: (e: any) => void;
    onNavigate: (e: any, resetFields: any, navigation: any, geoLevel: string) => void;
    carousel?: {
        type: string;
        markers: any[];
        currentIndex: number;
        uniqueKeyField: string;
    } | null;
    onCarouselNext?: () => void;
    onCarouselPrev?: () => void;
}

/**
 * MBPHoverPopup - Displays hover popup for My Business Presence markers
 * Supports carousel navigation when multiple MBPs are colliding
 */
export const MBPHoverPopup: React.FC<MBPHoverPopupProps> = ({
    presence,
    companyName,
    focusedPoi,
    roi,
    onClose,
    onNavigate,
    carousel,
    onCarouselNext,
    onCarouselPrev,
}) => {
    if (!presence?.unique_key) return null;

    return (
        <AdvancedMarker
            key={presence.unique_key}
            position={{
                lat: presence.latitude,
                lng: presence.longitude
            }}
            zIndex={200}
        >
            <PresenceHoverCard
                classname='presence-hover-popup'
                presence={presence}
                company_name={companyName}
                focusedPoi={focusedPoi}
                handleClose={onClose}
                handleNavigation={onNavigate}
                roi={roi}
                carousel={carousel}
                onCarouselNext={onCarouselNext}
                onCarouselPrev={onCarouselPrev}
            />
        </AdvancedMarker>
    );
};
